import { render, staticRenderFns } from "./RedPacketCard.vue?vue&type=template&id=20a7fd6b&scoped=true"
import script from "./RedPacketCard.vue?vue&type=script&lang=js"
export * from "./RedPacketCard.vue?vue&type=script&lang=js"
import style0 from "./RedPacketCard.vue?vue&type=style&index=0&id=20a7fd6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a7fd6b",
  null
  
)

export default component.exports